export type PageContent = Record<string, string | { code: string; text: string }[] | null>;

export const createGetText = (content: PageContent | undefined | null) => (key: string): string => {
    const value = content?.[key];
    return typeof value === "string" ? value : "";
};

export function getErrorMessage(
    content: PageContent | undefined | null,
    key: string,
    code: string | null
): string | null {
    if (!code) return null;
    const errors = content?.[key];
    return Array.isArray(errors) ? errors.find((e) => e.code === code)?.text ?? null : null;
}


export function getDateLocale(content: PageContent | undefined | null): string {
    const value = content?.["dateLocale"];
    return typeof value === "string" && value.trim() !== "" ? value.trim() : "en-GB";
}